import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';

@Component({
  selector: 'scaffold-text-link-label',
  templateUrl: './text-link-label.component.html',
  styleUrls: ['./text-link-label.component.scss']
})
export class TextLinkLabelComponent extends BaseScaffoldComponent implements OnInit {

  constructor (public cdr: ChangeDetectorRef,
    public renderedService: RenderedService) { super(cdr, renderedService); }

  ngOnInit () {
    if (this.item.text_value) {
      this.item.value = this.item.text_value.sort((a, b) => this.advancedSort(a, b)).join(this.item.seperator || ",");
    }
    if (this.item.prefix) {
      this.item.value = this.item.prefix + this.item.value;
    }
    if (this.item.sufix) {
      this.item.value = this.item.value + this.item.sufix;
    }
  }

  advancedSort (a: any, b: any) {
    if (isNaN(a) || isNaN(b)) {
      return this.sortStrings(a, b);
    }
    return this.sortNumbers(+a, +b);
  }

  sortNumbers (a, b) {
    return a - b;
  }

  sortStrings (a: any, b: any) {
    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
  }
}
